// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_02712f2b3b--tooltip--fEi5K","title":"_02712f2b3b--title--jOxbB"};